import { getCountryDataList } from "countries-list";

export default function getCountriesList() {
  let countries = getCountryDataList();
  const USAObject = countries.find((country) => country.iso2 === "US");
  countries = countries.filter((country) => country.name !== "United States");
  countries.unshift(USAObject);
  return countries;
}
